<template>
    <v-text-field
            prepend-inner-icon="credit_card"
            v-model="dni"
            clearable
            @click:clear="clearDNI"
            :loading="loading"
            @blur="validateUniqueness"
            :rules="rutRules"
            :error-messages="errorMessages"
            :label="'RUT' + (labelSuffix || '')"
            required
    ></v-text-field>
</template>
<script>

    import {rutValidator, rutFormat, debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'

    export default{
        props: ['defaultValue', 'labelSuffix', 'onChange', 'onValidationFail'],
        data(){
          return{
              dni: this.defaultValue || '',
              loading: false,
              exists: false,
              errorMessages: [],
              validatedDNI: '',
              rutRules:[
                  v => !!v || 'RUT es obligatorio',
                  rutValidator
              ]
          }
        },
        watch:{
            defaultValue(val){
                var vm = this
                vm.dni = rutFormat(val)
                if(typeof vm.onChange == 'function'){
                    vm.onChange(rutFormat(val))
                }
            },
            dni(val){
              var vm = this
              vm.dni = rutFormat(val)
              if(typeof vm.onChange == 'function'){
                  vm.onChange(rutFormat(val))
              }
            }
        },
        methods:{
            triggerValidationFailCallback(){
                var vm = this
                if(typeof vm.onValidationFail == 'function'){
                    vm.onValidationFail()
                }
            },
            clearDNI(){
              this.dni = ''
                this.errorMessages = []
            },
            debouncedUniqueness: debounce(function(){
                this.validateUniqueness()
            }, 1500),
            async validateUniqueness(){

                var vm = this
                if(!vm.dni || vm.validatedDNI === vm.dni) return

                vm.loading = true
                vm.errorMessages = ['Validando RUT...']
                const response = await ApiUtils.makeGet('public/user/exists/dni', {
                    dni: vm.dni
                })
                vm.loading = false
                vm.validatedDNI = vm.dni.toString()
                if(!response.ok){

                    const json = await response.json()
                    if(json.code == 400){
                        vm.errorMessages = [json.result.dni[0]]
                        vm.triggerValidationFailCallback()
                        return
                    }

                    vm.errorMessages = ['RUT no pudo ser validado']
                    vm.triggerValidationFailCallback()
                    return
                }

                const json = await response.json()
                vm.errorMessages = json.result.exists ? ['RUT ya fue registrado'] : []
                if(json.result.exists){
                    vm.triggerValidationFailCallback()
                }
                this.$emit('blurDNI')

            }
        }
    }
</script>